import bankapis  from "../../api/bank";

export default {
    name: "BankSiteList",
    data() {
        return {
            detailVisible:false,
            dataDetail:{},
            bankList:[],
            areaList:[],
            type:"add",
            query: {
                keyword: "",
                BankID:"",
                AreaCode:"",
                pageIndex: 1,
                pageSize: 10
            },
            tableCols:[
                {
                    "prop": "BankSiteID",
                    "label": "网点编号",
                    "width": "100",
                    "align": "center"
                },
                {
                  "prop": "BankName",
                  "label": "银行名称",
                  "width": "",
                  "align": "center"
                },
                {
                  "prop": "AreaName",
                  "label": "区域",
                  "width": "100",
                  "align": "center"
                },
                {
                    "prop": "BankSiteName",
                    "label": "网点名称",
                    "width": "",
                    "align": "center"
                },
                {
                    "prop": "CreateTime",
                    "label": "创建时间",
                    "width": "160",
                    "align": "center"
                },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "300",
                    "align": "center"
                }
            ],
            tableData:[],
            pageTotal: 0,
            scrollHeight:400,
        };
    },
    beforeCreate: function () {
      let meta = this.$route.meta
      if(meta&&meta.permBtns.length>0){
        this.permBtns = meta.permBtns
      }
  },
    created() {
      this.getData();
      this.getBankList();
      this.getAearList();
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    methods: {
        getData(){
          let param=this.query;
          bankapis.getBankSiteList(param).then(res => {
                            this.$data.tableData=res.list;
                            this.$data.pageTotal=res.count
                    });
    
      },
      getBankList(){
        let param= {
          keyword: "",
          pageIndex: 0,
          pageSize: 0
         };
        bankapis.getBankList(param).then(res => {
         this.bankList=res.list
         })
      },
      getAearList(){
        let param= {};
        bankapis.getAreaList(param).then(res => {
         this.areaList=res
         })
      },
      addOrUpdateBankSite(){
          let param=this.$data.dataDetail;
          if(param.BankSiteName==""){
            this.$message.error("名称不能为空");
            return;
          }
          if(param.BankID==""||param.AreaCode==""){
            this.$message.error("请选择区域或银行");
            return;
          }
          if(this.type=="add")this.addBankSite(param);
          else this.updateBankSite(param);
      
      },
      addBankSite(param){
        bankapis.addBankSite(param).then(res => {
          if(res===0){
           this.$message.success("新增成功");
             this.getData();
             this.$data.detailVisible=false;
          }else if(res===-2){
            this.$message.error("该网点名称已经存在");
          }else{
            this.$message.error("新增失败");
          }
      });
      },
       updateBankSite(param){
         bankapis.updateBankSite(param).then(res => {
                        if(res){
                         this.$message.success("修改成功");
                           this.getData();
                           this.$data.detailVisible=false;
                        }else{
                          this.$message.error("修改失败");
                        }
                    });
      },
        // 触发搜索按钮
        refreshList() {
            this.query.pageIndex = 1;
            this.getData();
        },
        handleEmpty(){
           this.$data.query={
            keyword: "",
            pageIndex: 1,
            pageSize: 10}
        },
        handleAdd(){
          this.$data.detailVisible=true;
          this.dataDetail={
            BankSiteName:"",
            BankID:"",
            AreaCode:""
          }
          this.type="add";
        },
        handleUpdate(index, row){
          this.$data.detailVisible=true;
          this.dataDetail={
            BankSiteName:row.BankSiteName,
            BankID:row.BankID,
            AreaCode:row.AreaCode,
            Id:row.BankSiteID
          }
          this.type="update";
        },
        // 删除操作
        handleDelete(index, row) {
            let that = this;
            if(row){
                that.$confirm('确定删除吗, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                  let param={
                    Id:row.BankSiteID
                  };
                 bankapis.deleteBankSite(param).then(res => {
                                if(res){
                                  that.$message.success("删除成功");
                                  that.getData();
                                }else{
                                  that.$message.error("删除失败");
                                }
                            });
                }).catch(() => {
                  that.$message({
                      type: 'info',
                      message: '已取消删除'
                    });
                });
            }
        },
        // 分页导航
        handlePageChange(val) {
            this.query.pageIndex = val;
            this.getData();
        },
        handleSizeChange(val){
            this.query.pageIndex = 1;
            this.query.pageSize = val;
            this.getData();
        },
        calcTableHeight(){
          this.$nextTick(() => {
            var height1=$(".content-box .content").height();
            var height2=$(".content-box .content .seach-container").height();
            var height=height1-height2-112-40;
            this.scrollHeight = height;
          });
        }
    },
  
  };
